import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, ReplaySubject } from 'rxjs';
import { AppSettings } from '../../../../../utils/app-settings';
import { tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class MessageCountService {

  constructor(private http: HttpClient) { }
  
  getUnreadMessageCount(): Observable<number> {
    return this.http.get<number>(AppSettings.apiUrl + "messages/unread_count");
  }
}


